/* global mixpanel */
import React from 'react'
import Button from 'react-bootstrap/lib/Button'
import Modal from 'react-bootstrap/lib/Modal'
import GA from "react-ga"
import * as componentUtils from '../../common/components/modals/time_entry_modal'
import { appStrings } from '../../common/strings/app_strings'
import { getItemsArray } from '../../util/prop_utils'
import { getKeyCode } from "../../util/random_utils"
import { calcDuration, confirmHighDuration } from '../../util/time_utils'
import { makeToast } from "../../util/toast_util"
import { ExpiredTrialAlertWindow } from "../alert_window"
import DescriptionField from '../description_field'
import StartEnd from '../start_end'
import TagSelect from '../tag_select'

const {
    alreadyUpdated,
    confirmDelete,
    futureTimeEntries,
} = appStrings.timeEntryModal

class TimeEntryModal extends React.Component {
    constructor(props) {
        super(props)
        this.stateSetter = this.stateSetter.bind(this)
        this.textOnChange = this.textOnChange.bind(this)
        this.showTimeFields = this.showTimeFields.bind(this)
        this.hideTimeFields = this.hideTimeFields.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleUpdate = this.handleUpdate.bind(this)
        this.handleKeyDown = this.handleKeyDown.bind(this)
        this.deleteRecord = this.deleteRecord.bind(this)
        this.handleSave = this.handleSave.bind(this)
        this.resetState = this.resetState.bind(this)
        this.renderStartEnd = this.renderStartEnd.bind(this)
        this.renderMobileTitle = this.renderMobileTitle.bind(this)

        this.initialState = {
            tags: [],
            description: "",
            startAt: null,
            endAt: null,
            updatedAt: null,
            showTimeFields: false,
            editMode: false,
            showAlertModal: false,
        }

        this.state = this.initialState
    }

    componentWillMount() {
        const props = this.props

        const entry = props.selectedEntryId ? this.loadEntry(props.selectedEntryId) : {}

        // showTimeFields (true for new entry, false for new timer)
        const stateUpdate = {
            ...entry,
            showTimeFields: props.showTimeFields,
        }

        const defaultTags = props.defaultTags ? componentUtils.getTagsAsOptions(props.defaultTags, props.tags.items, props.teams) : []

        const useDraft =
            !props.selectedEntryId &&
            props.restorePersistedNewEntryFields &&
            props.newEntryDraft

        let tags = defaultTags
        let description = entry.description != null ? entry.description : ""

        if (useDraft) {
            const { description: d, tagsSnapshot } = props.newEntryDraft
            if (typeof d === "string") {
                description = d
            }
            if (tagsSnapshot != null) {
                tags = componentUtils.deserializeTagsFromDraft(
                    tagsSnapshot,
                    props.tags.items,
                    props.teams,
                )
            }
        }

        // if selected entry, dont set startAt, otherwise set to defaultStartAt (currently selected day), any default tags
        const withStartAt = props.selectedEntryId ? stateUpdate
            : { ...stateUpdate, startAt: props.defaultStartAt, tags, description }

        this.setState(withStartAt)
    }

    hideAlertModal = () => {
        this.setState({ showAlertModal: false })
    }

    openUpgradeModal = () => {
        this.setState({ showAlertModal: false }, () => {
            this.props.setPaymentModalOpen(true)
        })
    }

    componentDidMount() {
        document.addEventListener("keydown", this.handleKeyDown)
    }
    componentWillUnmount() {
        this.hideAlertModal()
        document.removeEventListener("keydown", this.handleKeyDown)
    }

    loadEntry(id) {
        const { tags: tagIds, description, detail, startAt, endAt, updatedAt } = this.props.timeEntries.items[id]

        return {
            editMode: true,
            showTimeFields: true,
            tags: componentUtils.getTagsAsOptions(tagIds, this.props.tags.items, this.props.teams),
            description,
            detail,
            startAt,
            endAt,
            updatedAt,
        }
    }

    resetState() {
        this.setState(this.initialState)
    }

    stateSetter(field) {
        return value => this.setState({ [field]: value })
    }

    textOnChange(field) {
        return e => this.setState({ [field]: e.target.value })
    }

    showTimeFields() {
        this.setState({
            showTimeFields: true,
            startAt: this.state.startAt || Date.now(),
        }, this.startEnd.selectStart)
        this.props.onNewTimeEntry()
    }

    hideTimeFields() {
        this.setState({showTimeFields: false})
    }

    handleClose(skipDraftPersist) {
        const { editMode, description, tags } = this.state
        if (
            !skipDraftPersist &&
            !editMode &&
            !this.props.isStartTimer &&
            this.props.showTimeFields &&
            this.props.onPersistNewEntryDraft
        ) {
            this.props.onPersistNewEntryDraft({
                description,
                tagsSnapshot: componentUtils.serializeTagsForDraft(tags),
            })
        }
        this.hideTimeFields()
        this.props.onClose()
    }

    handleUpdate(meta, updatedAt) {
        const recordUpdatedAt = this.props.timeEntries.items[this.props.selectedEntryId].updatedAt
        if (recordUpdatedAt !== updatedAt) {
            const action = {
                text: "OKAY",
                onClick: () => {
                    this.handleClose()
                },
            }
            makeToast(alreadyUpdated, "warning", action)
            return
        }
        this.handleClose()
        return this.props.updateTimeEntry({ ...meta, id: this.props.selectedEntryId })
    }

    deleteRecord() {
        const { selectedEntryId, deleteTimeEntry, timeEntries } = this.props
        const timeEntry = timeEntries.items[selectedEntryId]

        // toast
        const ind = "warning"
        const action = {
            text: "YES",
            onClick: () => {
                deleteTimeEntry(timeEntry)
                this.handleClose()
            },
        }
        makeToast(confirmDelete, ind, action)
    }

    createTag(option) {
        const { profile } = this.props
        // TODO: Multiteam maybe
        return {
            name: option.name,
            color: option.color,
            userId: profile.id,
            teamId: profile.personalTeamId,
        }
    }

    handleSave() {
        const { profile, teams } = this.props
        const { startAt, endAt, tags, description, detail, updatedAt, editMode } = this.state
        const teamTag = componentUtils.getFirstTeamTag(tags, profile.personalTeamId)
        // TODO: Multiteam
        const teamId = teamTag.teamId || profile.personalTeamId
        const tagIds = tags.filter(tag => tag.id).map(tag => tag.id)
        const newTagMeta = tags
            .filter(tag => !tag.id)
            .map(tag => this.createTag(tag))
            
        // do not save if using tags for expired teams
        if (
            ! editMode && !!componentUtils.getFirstExpiredTeam(
                tags,
                teams,
                profile.personalTeamId,
            )
        ) {
            this.setState({ showAlertModal: true })
            return
        }

        const timeEntryMeta = {
            userId: profile.id,
            teamId,
            startAt: startAt || Date.now(),
            endAt,
            tags: tagIds,
            newTags: newTagMeta,
            description,
            detail,
        }

        if (!confirmHighDuration(timeEntryMeta)) return
        
        if (timeEntryMeta.startAt > Date.now() && !endAt) {
            makeToast(futureTimeEntries, "warning")

            return
        }

        editMode
            ? this.handleUpdate(timeEntryMeta, updatedAt)
            : this.props.createTimeEntry(timeEntryMeta)

        if (!editMode) {
            if (this.props.onClearPersistedNewEntryDraft) {
                this.props.onClearPersistedNewEntryDraft()
            }
            this.handleClose(true)
        }

        const { userId: creatorId } = timeEntryMeta
        // TODO: Multiteam
        mixpanel.track(`${editMode ? "Update" : "Create"} time entry - modal`, { teamId, creatorId, tagCount: tags.length, timeEntryId: this.props.selectedEntryId })
        GA.event({category: "User", action: `${editMode ? "Update" : "Create"} time entry - modal`})
    }

    handleKeyDown(event) {
        const CONTROL = event.getModifierState("Control")
        const COMMAND = event.getModifierState("Meta")
        const code = getKeyCode(event.keyCode)

        if (code === "KEY_ENTER" && (CONTROL || COMMAND)) {
            event.preventDefault()
            this.handleSave()
        }
    }

    renderStartEnd() {
        const { showTimeFields, startAt, endAt, editMode } = this.state
        const { isMobile, isStartTimer, onNewTimeEntry } = this.props

        return (
            <StartEnd ref={(component) => { this.startEnd = component }}
                isStartTimer={isStartTimer}
                onNewTimeEntry={onNewTimeEntry}
                show={showTimeFields}
                startAt={startAt}
                endAt={endAt}
                editMode={editMode}
                onStartChange={this.stateSetter('startAt')}
                onEndChange={this.stateSetter('endAt')}
                isMobile={isMobile}
                stopNow={() => {this.setState({endAt: Date.now()})}}
            />
        )
    }

    renderMobileTitle() {
        const { editMode, endAt } = this.state
        const { onNewTimeEntry, onStartTimer, isStartTimer } = this.props
        const isRunning = endAt === 0
        const time = calcDuration(this.state)

        const TimeEntryTitleButtons = (
            <div className='mobile-time-entry-button-row'>
                <button onClick={ () => onNewTimeEntry() } className={`btn btn-default btn-new-entry ${!isStartTimer && 'selected'}`}>
                    <i className="fa fa-list-alt" aria-hidden="true" />
                    <p>New Entry</p>
                </button>
                <button onClick={ () => onStartTimer() } className={`btn btn-default btn-start-timer ${isStartTimer && 'selected'}`}>
                    <i className="fa fa-clock-o" aria-hidden="true" />
                    <p>Start Timer</p>
                </button>
            </div>
        )

        const EditTimeEntryTitle = (
            <div className='edit-time-entry-title'>
                {isRunning ? 'Edit Running Timer' : 'Edit Entry'}
                <span>{time} {isRunning ? 'hours...' : 'hours '}</span>
            </div>
        )

        return editMode
            ? EditTimeEntryTitle
            : TimeEntryTitleButtons
    }

    render() {
        const { tags, recentTagCombos, teams, profile: { personalTeamId, id: profileId }, defaultTags, selectedTeamId, viewerIsTeamAdmin, isMobile } = this.props
        const tagMap = tags.items
        const { showTimeFields, editMode } = this.state
        const title = isMobile
            ? this.renderMobileTitle()
            : editMode ? "Edit Entry" : "New Entry"
        const expiredTeam = componentUtils.getFirstExpiredTeam(this.state.tags, teams, profileId) 

        // TODO: Multiteam
        const tagFilter = tag => !!tag
        const comboTagSorter = (a, b) => a.teamId === personalTeamId && b.teamId !== personalTeamId ?  1 :
            a.teamId !== personalTeamId && b.teamId === personalTeamId ? -1 : 0
        const filteredTags = getItemsArray(tags)
            .filter( tagFilter )
            .filter( tag => !tag.isArchived )
            .sort( (a, b) => a.name === b.name ? 0 : a.name > b.name ? 1 : -1 )
        const filteredCombos = recentTagCombos
            .map( combo => { combo.tags = combo.tags.map( tagId => tagMap[tagId] )
                .filter( tagFilter )
                .filter( tag => !tag.isArchived )
                .sort( comboTagSorter )
                .map( tag => tag.id); return combo } )
            .filter( combo => combo.tags.length > 0)
        const safeParse = val => {
            try {
                return JSON.parse(val)
            } catch (e) {
                return null
            }
        }
        const detailJson = this.state.detail 
            ? safeParse(this.state.detail) : null

        return (
            <Modal show={true} onHide={this.handleClose} className="modal-v2 modal-v2-time-entry">
                <Modal.Header closeButton>
                    <div className="modal-title">{title}</div>
                    <Button onClick={this.handleSave} className="">Save</Button>
                </Modal.Header>
                {isMobile && this.renderStartEnd()}
                <Modal.Body className="tag-description-body">
                    <TagSelect
                        recentTagCombos={filteredCombos}
                        tags={filteredTags}
                        tagMap={tagMap}
                        teams={teams}
                        values={this.state.tags}
                        onValuesChange={this.stateSetter('tags')}
                        placeholder="Tags"
                        autofocus={isMobile ? false : (!editMode && !defaultTags)}
                        selectedTeamId={selectedTeamId}
                        viewerIsTeamAdmin={viewerIsTeamAdmin}
                        viewerPersonalTeamId={personalTeamId}
                    />
                    {detailJson && (
                        <div className='detail'>
                            <div className='detail-internal'>
                                <div className='header'>{detailJson.header}</div>
                                {detailJson.link && detailJson.linkDescription && (
                                    <div><a href={detailJson.link} target="_blank">{detailJson.linkDescription}</a></div>
                                )}
                                {detailJson.text && (
                                    <div className="text">{detailJson.text}</div>
                                )}
                            </div>
                        </div>
                    )}
                    <DescriptionField
                        value={this.state.description}
                        onChange={this.textOnChange('description')}
                        autoFocus={isMobile ? false : (editMode || defaultTags)}
                        minRows={isMobile ? 7 : 1}
                    />
                    <ExpiredTrialAlertWindow
                        isOpen={this.state.showAlertModal}
                        handleCloseAlert={this.hideAlertModal}
                        team={expiredTeam}
                        type="TIME_ENTRY"
                        upgrade={this.openUpgradeModal}
                        personalTeamId={personalTeamId}
                        userId={profileId}
                    />
                </Modal.Body>
                {!isMobile && this.renderStartEnd() }
                <Modal.Footer>
                    {editMode &&
                        <span className="trash-container">
                            <i className="fa fa-trash-o" onClick={this.deleteRecord.bind(this)}></i>
                        </span>
                    }
                    {!showTimeFields &&
                        <span>
                            <span className="start-at">Starting now</span>
                            <Button className="btn-info btn-sm" onClick={this.showTimeFields}>Change Time</Button>
                        </span>}

                    {!isMobile && <Button onClick={this.handleSave} className="btn-primary btn-spacer">Save</Button>}
                </Modal.Footer>
            </Modal>
        )
    }
}

export default TimeEntryModal



// WEBPACK FOOTER //
// ./src/components/modals/time_entry_modal.jsx